document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("service");
  if (!root) return;

  const mobileCard = root.querySelector("#cardBuyMobileCard");
  const panel = root.querySelector("#mobileFormPanel");
  const mobileMount = root.querySelector("#mobileFormMount");
  const desktopMount = root.querySelector("#serviceFormMount");
  const btn = root.querySelector("#btnOpenMobileForm");

  const headerBar = mobileCard ? mobileCard.querySelector(".card-mobile__container") : null;

  if (!mobileCard || !panel || !mobileMount || !desktopMount || !btn || !headerBar) return;

  const overlay = document.createElement("div");
  overlay.className = "card-mobile-overlay";
  overlay.setAttribute("aria-hidden", "true");
  mobileCard.parentElement.appendChild(overlay);

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "card-mobile__close";
  closeBtn.setAttribute("aria-label", "Cerrar");
  closeBtn.textContent = "\u00D7";
  panel.insertBefore(closeBtn, panel.firstChild);

  let listenersActive = false;

  function getFormNodeFrom(container) {
  return (
    container.querySelector("#wp-service-form") ||
    container.querySelector('[id^="wp-service-form"]') ||
    container.querySelector(".p-service-form-page") ||
    container.querySelector(".p-service-form") ||
    container.querySelector("form") ||
    container.firstElementChild ||
    null
  );
}

  function isOpen() {
    return mobileCard.classList.contains("is-open");
  }

  function attachCloseListeners() {
    if (listenersActive) return;
    listenersActive = true;
    document.addEventListener("click", onOutsideClick, true);
    document.addEventListener("keydown", onKeydown, true);
  }

  function detachCloseListeners() {
    if (!listenersActive) return;
    listenersActive = false;
    document.removeEventListener("click", onOutsideClick, true);
    document.removeEventListener("keydown", onKeydown, true);
  }

  function openMobile() {
    const formNode = getFormNodeFrom(desktopMount);
    if (!formNode) return;

    mobileMount.appendChild(formNode);

    mobileCard.classList.add("is-open");
    overlay.classList.add("is-visible");
    btn.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");
    document.body.classList.add("p-overflow-hidden");

    attachCloseListeners();

    panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function closeMobile() {
    const formNode = getFormNodeFrom(mobileMount);
    if (formNode) desktopMount.appendChild(formNode);

    mobileCard.classList.remove("is-open");
    overlay.classList.remove("is-visible");
    btn.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
    document.body.classList.remove("p-overflow-hidden");

    detachCloseListeners();
  }

  function onOutsideClick(e) {
    if (!isOpen()) return;

    if (!root.contains(e.target)) return;

    if (panel.contains(e.target)) return;

    closeMobile();
  }

  function onKeydown(e) {
    if (!isOpen()) return;
    if (e.key === "Escape") closeMobile();
  }

  btn.addEventListener("click", function (e) {
    e.preventDefault();
    if (!isOpen()) openMobile();
  });

  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeMobile();
  });

  overlay.addEventListener("click", closeMobile);

  window.addEventListener("resize", function () {
    if (window.innerWidth >= 1024 && isOpen()) closeMobile();
  });
});
